import { useState } from 'react'
import { Box, Accordion, AccordionSummary, AccordionDetails, Typography, Link, Collapse } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked'
import { formatTimeToAmPm } from 'services/helper/DateTime'
import MapImage from '../../module/time-attendance/components/MapImage'

const AdxTimelineViewer = ({ timeline }) => {
  const [expanded, setExpanded] = useState(false)
  const [showMap, setShowMap] = useState({})

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  // const toggleMap = (index) => {
  //   setShowMap(prev => ({
  //     ...prev,
  //     [index]: !prev[index]
  //   }))
  // }

  return (
    <Box sx={{ width: '100%' }}>
      {timeline.map((point, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <RadioButtonCheckedIcon
                sx={{
                  color:
                    index === 0 || index === timeline.length - 1
                      ? 'alternate.main'
                      : 'gray-line.main',
                }}
              />
              <Box sx={{ display: 'flex', gap: 1, pl: 1.75 }}>
                <Typography variant="subtitle1">
                  {point.time ? formatTimeToAmPm(point.time) : '--:--'}
                </Typography>
                <Typography> • </Typography>
                <Typography variant="body1">
                  {index !== timeline.length - 1 ? 'Clock In' : 'Clock Out'}
                </Typography>
              </Box>
            </Box>

            {/* View Map Link */}
            {/* {point.coordinates && point.coordinates.latitude && point.coordinates.longitude && (
              <Link
                component="button"
                variant="body2"
                onClick={() => toggleMap(index)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  textDecoration: 'none',
                  color: 'primary.main',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                {showMap[index] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                {showMap[index] ? 'Hide Map' : 'View Map'}
              </Link>
            )} */}

          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              ...(index !== timeline.length - 1
                ? {
                  borderLeft: '1px solid',
                  borderColor: 'gray-line.main',
                }
                : { borderLeft: '1px solid', borderColor: 'transparent' }),
              ml: 1.5,
              pl: 3,
              pt: 1,
              pb: 2.5,
            }}
          >
            <Typography sx={{ color: 'light-gray-text.main' }}>
              {point.location ? point.location : '[No location recorded]'}
            </Typography>

            {/* Map Display */}
            <Collapse in={showMap[index]}>
              {point.coordinates && point.coordinates.latitude && point.coordinates.longitude && (
                <Box sx={{ mt: 2 }}>
                  <MapImage
                    latitude={parseFloat(point.coordinates.latitude)}
                    longitude={parseFloat(point.coordinates.longitude)}
                    width={400}
                    height={200}
                    zoom={15}
                  />
                </Box>
              )}
            </Collapse>
            {point.note && (
              <Box sx={{ display: 'flex' }}>
                <Accordion
                  sx={{
                    width: '100%',
                    backgroundColor: 'light-information.main',
                    boxShadow: 'none',
                    borderRadius: '4.5px',
                  }}
                  square={true}
                  expanded={expanded === index}
                  onChange={handleChange(index)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: 'information.main' }} />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <DescriptionOutlinedIcon sx={{ color: 'information.main' }} />
                      <Typography
                        sx={{
                          textDecoration: expanded === index ? 'none' : 'underline',
                          color: 'information.main',
                        }}
                      >
                        {expanded === index ? 'Notes' : 'View notes'}
                      </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails sx={{ color: 'light-gray-text.main' }}>
                    {point.note}
                  </AccordionDetails>
                </Accordion>
              </Box>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default AdxTimelineViewer
